export default __webpack_public_path__ + "assets/images/4010af062a2643637a8a601b29a3ff25.png";